import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import srcVirtualAgentBrowseConversationsQuery from '@atlassian/jira-relay/src/__generated__/srcVirtualAgentBrowseConversationsQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const DEFAULT_RANGE_DAYS = 14;

export const browseConversationsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-virtual-agent-browse-conversations" */ './src'),
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const end = new Date();
		const start = new Date(end);
		start.setDate(start.getDate() - DEFAULT_RANGE_DAYS);

		return {
			extraProps: {
				initialDateRange: {
					start,
					end,
				},
			},
			queries: {
				page: {
					parameters: srcVirtualAgentBrowseConversationsQuery,
					variables: {
						cloudId: tenantContext.cloudId,
						projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
						startDate: start.toISOString(),
						endDate: end.toISOString(),
					},
				},
			},
		};
	},
});
